import Header from '../components/Canvas/Header'
import Sidebar from '../components/Canvas/Sidebar';
import Topbar from '../components/Canvas/Topbar';
import Canvas from '../components/Canvas/Canvas';
import {useState, useEffect, useRef} from 'react';
import blogImage from '../../images/blog-placeholder.png';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../css/template-editor.css';

import { Link, useHistory, useParams } from "react-router-dom";
import Cookies from "universal-cookie";

// import wm_QR_code from '../assets/images/wm_qr.png';
import { createCertificateTemplate, getCertificateTemplates, getImageMedia, updateCertificateTemplate, uploadImageMedia } from '../../apis/TemplateAPI';

const cookies = new Cookies();

const TemplateEditor = () => {
  toast.configure();
  const {clientId} = useParams();
  const history = useHistory();
    //State for currently selected item
  const [currentlySelected, setCurrentlySelected] = useState({type: null, index: null});

  const [selectedTemplate, setSelectedTemplate] = useState();
  const [templateName, setTemplateName] = useState("");
  const [editTemplate, setEditTemplate] = useState(false);

  //State for canvas orientation
  const [orientation, setOrientation] = useState("landscape");
  
  const [templates, setTemplates] = useState();

  const [savedData, setSavedData] = useState("");

  //State for Background
  const [background, setBackground] = useState(null);
  const [bgImageObject, setBgImageObject] = useState(null);

  //State for Images
  const [imageObjects, setImageObjects] = useState([]);
  const [selectedImageKey, setSelectedImageKey] = useState(null);

  const [currentImage, setCurrentImage] = useState("");
  const [imageMedia, setImageMedia] = useState();
  const [textBoxRotation, setTextBoxRotation] = useState();

  //State for Certificates
  const [certNoState, setCertNoState] = useState();
  const [selectedCertNo, setSelectedCertNo] = useState(false);
  const [certPrefix, setCertPrefix] = useState("CNO");

  const stageRef = useRef();
  
  //State for Text and Image Objects
  const [objectState, setObjectState] = useState([]);

  const [objectIndex, setObjectIndex] = useState(0);

  //State of inputs to edit the text
  const [currentTextKey, setCurrentTextKey] = useState();
  const [fontSize, setFontSize] = useState(12);
  const [isBold, setTextBold] = useState("");
  const [isItalic, setTextItalic] = useState("");
  const [textDecoration, setTextDecoration] = useState("");
  const [fontFamily, setFontFamily] = useState("Arial");
  const [textColor, setTextColor] = useState("#000000");
  const [textAlignment, setTextAlignment] = useState("left");

  const fontList = ["Arial", "Times New Roman", "Courier New", "Calibri"];

  //Text Area state, which is used to edit text values in TextBox
  const [textAreaVisibility, setTextAreaVisibility] = useState("none");
  const [textAreaStyle, setTextAreaStyle] = useState({});
  const[currentTextBoxText, setCurrentTextBoxText] = useState(null);

  const token = cookies.get("token");
  // const clientId = token?.id;

  useEffect(() => {
    if(token === undefined || token === null) {
      history.push("/page-login");
    } else {
      getCertificateTemplates(token,token?.id)
      .then(response => {
        setTemplates(response.data)
      })
      .catch(err => {
        toast.error("Error while retrieving templates.", {
          position: 'top-left',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: false
        })
      })
    getImageMedia(token)
      .then(response => {
        setImageMedia(response.data);
      })
      .catch(err => {
        toast.error("Error while retrieving image media.", {
          position: 'top-left',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: false
        })
      })
    }
  }, [])

  //TextBox Methods
  const createTextBox = (isCertNo) => {
    const key = objectIndex;
    setObjectIndex(key+1);

    if(isCertNo == "CertNo") {
      setObjectState(objectState.concat({
        index: key,
        type: "certNo",
        text: certPrefix+"-No.",
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle:  (isBold + " " + isItalic).trim(),
        textDecoration: textDecoration,
        textAlignment: textAlignment,
        rotation: 0,
        textColor: textColor,
        // width: fontSize * 7,
        textAlignment: textAlignment,
        isSelected: false,
        type: isCertNo,
        x: 50,
        y: 50
      }));
    }
    else {
      setObjectState(objectState.concat({
        index: key,
        type: "text",
        text: "Text Box "+key,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle:  (isBold + " " + isItalic).trim(),
        textDecoration: textDecoration,
        textAlignment: textAlignment,
        rotation: 0,
        textColor: textColor,
        // width: fontSize * 7,
        isSelected: false,
        type: isCertNo,
        x: 50,
        y: 50
      }));
    }
  }

  const onTextBoxSelect = (e, key) => {
    setCurrentTextKey(key);
    setCurrentlySelected({ type: "EditableText", index: key });

    setSelectedImageKey(null);

    let newState = objectState;

    for(let i=0; i<newState?.length; i++) {
        if(newState[i]?.index == key) {
            newState[i].x = e.attrs.x;
            newState[i].y = e.attrs.y;    
            setCurrentTextBoxText(newState[i].text);
        }
    }

    setObjectState([...newState]);
  }

  const onTextBoxChange = (key, updatedVars) => {
    let newState = objectState;

    console.log(updatedVars)

    for(let i=0; i<newState?.length; i++) {
        if(newState[i]?.index == key) {
            newState[i].x = updatedVars.x;
            newState[i].y = updatedVars.y;
            newState[i].fontSize = updatedVars.fontSize;
            newState[i].rotation = updatedVars.rotation;
            newState[i].width = updatedVars.width;     
            newState[i].height = updatedVars.height;       
        }
    }

    setObjectState([...newState]);
  }

  const addTextArea = (coordinates) => {
    setTextAreaVisibility("block");
    setTextAreaStyle({x: coordinates.x, y: coordinates.y, width: coordinates.width, height: coordinates.height, 
                      fontSize: coordinates.fontSize, lineHeight: coordinates.lineHeight, textColor: coordinates.textColor});
  }

  // Image Methods
  const onImageSelect = (e, key) => {
    setSelectedImageKey(key);

    setCurrentTextKey(null);

    setCurrentlySelected({ type: "EditableImage", index: key });
  }

  const onImageChange = (key, updatedVars) => {
    let newState = objectState;

    for(let i=0; i<newState?.length; i++) {
        if(newState[i]?.index == key) {
            newState[i].x = updatedVars.x;
            newState[i].y = updatedVars.y;
            newState[i].width = updatedVars.width;
            newState[i].height = updatedVars.height;
            newState[i].rotation = updatedVars.rotation;
        }
    }

    setObjectState([...newState]);
  }

  const createNewTemplate = () => {
    setEditTemplate(false)
    setTemplateName("")

    setObjectState([]);
    setBackgroundImage(null);
    setOrientation("landscape")
    setObjectIndex(0);
    setBgImageObject(null);
  }

  const loadTemplate = () => {

    if(selectedTemplate === "" || selectedTemplate === undefined || selectedTemplate === null) {
      toast.error("Please select a template to open.", {
        position: 'top-left',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: false
      })
      return;
    }

    let state;

    for(let j=0; j<templates?.length; j++) {
      if(templates[j]?.template_id === selectedTemplate) {
        // return;
        state = JSON.parse(templates[j]?.meta);
      }
    }

    for(let i=0; i<state?.objectState.length; i++) {
      if(state.objectState[i].type === "TextBox" || state.objectState[i].type === "CertNo") {
        state.objectState[i].fontFamily = state.objectState[i].fontFamily.replaceAll("-", " ");
      }

      if(state.objectState[i].type === "Image" || state.objectState[i].type === "QrCode") {
        let newImage = new Image();

        newImage.src = state.objectState[i].imgURL;
        newImage.crossOrigin = 'Anonymous';

        state.objectState[i].image = newImage;
      }

      if(i == state?.objectState.length - 1) {
        setObjectIndex(state?.objectState[i]?.index + 1);
      }

      for(let i=0; i<templates?.length; i++) {
        if(templates[i]?.template_id === selectedTemplate) {
          setTemplateName(templates[i]?.template_name);
        }
      }
    }

  if(state?.background?.imgURL !== "" && state?.background?.imgURL !== null && state?.background?.imgURL !== undefined) {
    let bgImage = new Image();
    bgImage.crossOrigin = 'Anonymous';
    bgImage.src = state?.background?.imgURL;
    setBgImageObject(bgImage);
  }

    setObjectState(state?.objectState);
    setBackground(state?.background);
    setOrientation(state?.orientation);
    setEditTemplate(true);
  }

  const createImage = (isQrCode) => {
    if(currentImage || isQrCode === "QrCode") {
    const key = objectIndex;
    setObjectIndex(key+1);

    // fetch(currentImage
    //   ,{mode: 'cors'}
    //   )
    //   .then(response => {
    //     console.log(response)
    //     response.blob()
    //     .then(blob => {
    //       console.log(blob);           
    // })
    //   })
    //   .catch(err => {
    //     console.log(err)
    //   })

    //   return;
    let newImage = new Image();
    newImage.crossOrigin = 'Anonymous';
    
    if(isQrCode === "QrCode") {
      // newImage.src = wm_QR_code;
      newImage.src = "";
      setImageObjects(imageObjects.concat(newImage));

      setObjectState(objectState.concat({
        index: key,
        imgURL: "https://smedia.wisemonkeys.info/13211636432285/certificate/resources/certimage/b18061db9a628c77225b39e15244f3d5.png",
        width: newImage.width/6,
        height: newImage.height/6,
        image: newImage,
        type: isQrCode,
        x: 50,
        y: 50,
        rotation: 0
      }))
    } 
    else if(isQrCode === "Image") {
      newImage.src = currentImage;
      console.log("img", newImage);
      
      newImage.onload = function(){
        var height = newImage.height;
        var width = newImage.width;

        setImageObjects(imageObjects.concat(newImage));

        setObjectState(objectState.concat({
            index: key,
            imgURL: currentImage,
            width: width/2,
            height: height/2,
            image: newImage,
            type: isQrCode,
            x: 50,
            y: 50,
            rotation: 0
        }))
      }
    }
    }
  }

  const setBackgroundImage = (add) => {
    if(currentImage) {
      if(add) {
        let newImage = new Image();
        newImage.src = currentImage;
        newImage.crossOrigin = 'Anonymous';

        setBgImageObject(newImage);
        setBackground({ imgURL: currentImage });
        }
      else {
        setBgImageObject(null);
        setBackground({ imgURL: "" })
      }  
    }
  }

  useEffect(() => {
    // for(let i=0; i<templates?.length; i++) {
    //   if(templates[i]?.template_id === selectedTemplate) {
    //     setTemplateName(templates[i]?.template_name);
    //   }
    // }
   }, [selectedTemplate])

  // UseEffect Hooks
  useEffect(() => {
    let selectedText;

    if(currentTextKey || currentTextKey == 0) {
        for(let i=0; i < objectState?.length; i++) {
            if(currentTextKey == objectState[i]?.index) {
                selectedText = objectState[i];                
            }
        }

      if(selectedText?.fontStyle == "bold italic") {
         setTextBold("bold");
         setTextItalic("italic");
      }
      else if(selectedText?.fontStyle == "bold") setTextBold("bold");
      else if(selectedText?.fontStyle == "italic") setTextItalic("italic");
      else {
        setTextBold("");
        setTextItalic("");
      }

      // console.log(selectedText)

      setFontFamily(selectedText?.fontFamily);
      setFontSize(selectedText?.fontSize);
      setTextDecoration(selectedText?.textDecoration);
      setCurrentTextBoxText(selectedText?.text);
      setTextBoxRotation(selectedText?.rotation)
      setTextColor(selectedText?.textColor);
    }
  }, [currentTextKey, selectedCertNo]); 
  
  useEffect(() => {
    if(currentTextKey || currentTextKey == 0) {
      let selectedText = objectState.filter((element) => { return element.index == currentlySelected?.index });
      selectedText = selectedText[0];

      let newState = objectState;
      
      for(let i=0; i<newState?.length; i++) {
            if(newState[i]?.index == currentlySelected.index) {
                newState[i].fontFamily = fontFamily;
                newState[i].fontSize = fontSize;
                newState[i].fontStyle = (isBold+" "+isItalic).trim();
                newState[i].textDecoration = textDecoration;
                newState[i].text = currentTextBoxText;
                newState[i].textColor = textColor;
                newState[i].textAlignment = textAlignment;
            }
        }

      setObjectState([...newState]);
    } 
    else if(selectedCertNo) {
      let selectedText = objectState.filter((element) => { return element.index == currentTextKey });
      selectedText = selectedText[0];

      let newState = objectState;

      for(let i=0; i<newState?.length; i++) {
        if(newState[i]?.index == currentlySelected.index) {
            newState[i].fontFamily = fontFamily;
            newState[i].fontSize = fontSize;
            newState[i].fontStyle = (isBold+" "+isItalic).trim();
            newState[i].textDecoration = textDecoration;
            newState[i].text = currentTextBoxText;
            newState[i].textColor = textColor;
            newState[i].textAlignment = textAlignment;
            }
        }      
    }
  }, [fontFamily, fontSize, currentTextBoxText, isBold, isItalic, textDecoration, textAlignment, textColor]);

  // Delete and Unselect Methods
  const checkDeselect = (e) => {
    const clickedOnEmpty = e.target.attrs.id === "bg-image"; 
    if(clickedOnEmpty) {
      setSelectedImageKey(null);
      setCurrentTextKey(null);
      setTextAreaVisibility("none");
      setCurrentlySelected({type: null, index: null});
    }
  }

  const shiftUp = () => {
    let currentIndex = currentlySelected?.index;
    let arrayIndex = null;

    for(let i=0; i<objectState?.length; i++) {
      if(objectState[i]?.index == currentIndex) {
        arrayIndex = i;
      }
    }

    let newState = objectState;

    if(!(arrayIndex+1 > newState.length +1)) {
      let temp = newState[arrayIndex];
      newState[arrayIndex] = newState[arrayIndex+1];
      newState[arrayIndex+1] = temp; 
    }

    setObjectState([...newState]);
  }

  const shiftDown = () => {
    let currentIndex = currentlySelected?.index;
    let arrayIndex = null;

    for(let i=0; i<objectState?.length; i++) {
      if(objectState[i]?.index == currentIndex) {
        arrayIndex = i;
      }
    }

    let newState = objectState;

    if(!(arrayIndex-1 < 0)) {
      let temp = newState[arrayIndex];
      newState[arrayIndex] = newState[arrayIndex-1];
      newState[arrayIndex-1] = temp; 
    }

    setObjectState([...newState]);
  }

  const deleteItem = () => {
    if(currentlySelected.type === "EditableText") {
      let newState = [];
           
      for(let i=0; i<objectState?.length; i++) {
          if(objectState[i]?.index != currentlySelected.index) {
              newState.push(objectState[i]);
            }
        }
      setObjectState([...newState]);

      setCurrentlySelected({type: null, index: null});
      setCurrentTextKey(null);
    }
    else if(currentlySelected.type === "EditableImage") {
      let newState = [];

    for(let i=0; i<objectState?.length; i++) {
        if(objectState[i]?.index != currentlySelected.index) {
            newState.push(objectState[i]);
          }
      }
      setObjectState([...newState]);
      setCurrentlySelected({type: null, index: null});
    }
    else {

    }
  }

  function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
  }

  const getCanvasSnapshot = () => {
    try {
      const uri = stageRef.current.toDataURL();

      const imageBlob = dataURLtoBlob(uri)
      console.log(uri)
      imageBlob.lastModifiedDate = new Date();
      imageBlob.name = "thumb" + new Date().getTime() + Math.floor(Math.random() * 100000)+".png" ;
      let fileName = "thumb" + new Date().getTime() + Math.floor(Math.random() * 100000)+".png" ;
  
      let imageFile = new File([imageBlob], fileName, {type: "image/png"})
  
      // uploadImageMedia(token, token?.id, "thumb", imageFile)
      return imageFile;  
    }
    catch(err) {
      const imageBlob = dataURLtoBlob(blogImage)
        imageBlob.lastModifiedDate = new Date();
        imageBlob.name = "thumb" + new Date().getTime() + Math.floor(Math.random() * 100000)+".png" ;
        let fileName = "thumb" + new Date().getTime() + Math.floor(Math.random() * 100000)+".png" ;
    
        let imageFile = new File([imageBlob], fileName, {type: "image/png"})
    
        // uploadImageMedia(token, token?.id, "thumb", imageFile)
        return imageFile;  
    }
  }

  // Log JSON coordinates and other attributes of the canvas
  const saveTemplate = (templateThumbId) => {
    const tempState = {objectState, background, orientation}    
    const state = JSON.parse(JSON.stringify(tempState));
    let templateUrlId = 0;

    for(let i=0; i<state.objectState.length; i++) {
      if(state.objectState[i].type === "TextBox" || state.objectState[i].type === "CertNo") {
        state.objectState[i].fontFamily = state.objectState[i].fontFamily.replaceAll(" ", "-");
      }

      if(state.objectState[i].type === "CertNo") {
        state.objectState[i].text = state.objectState[i].text.substring(0, state.objectState[i].text.indexOf("-"));
      }
    }

    if(templateName === "" || templateName === null || templateName === undefined) {
      toast.error("Please add a template name before saving.", {
        position: 'top-left',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: false
      })
      return;
    }

    const imageFile = getCanvasSnapshot();

    if(editTemplate) {
      updateCertificateTemplate(token, token?.id, selectedTemplate, templateName, state, imageFile)
        .then(response => {
          let newTemplatesData = templates;
          for(let i=0; i<newTemplatesData?.length; i++) {  
            if(newTemplatesData[i]?.template_id === selectedTemplate) {
              newTemplatesData[i].template_name = templateName;
            }
          }

          setTemplates([...newTemplatesData])

          toast.success("Template updated with name '"+templateName+"'", {
            position: 'top-left',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: false
          })

        })
        .catch(err => {
          toast.error("Error while updating template.", {
            position: 'top-left',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: false
          })
        })
    } else {
      uploadImageMedia(token, clientId, "thumb", imageFile)
        .then(response => {
          console.log(response)
          console.log(response?.thumb_id)
          console.log(response?.data?.thumb_id)
          createCertificateTemplate(token, token?.id, templateName, state, response?.data?.thumb_id)
          .then(response => {
            toast.success("Template saved with name '"+templateName+"'", {
              position: 'top-left',
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: false
            })
          })
          .catch(err => {
            toast.error("Error while saving template.", {
              position: 'top-left',
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: false
            })
          })
        })
    }
  }

  return (
    <div>
      <Header
        saveTemplate={saveTemplate}
        templates={templates}
        savedData={savedData}
        setSelectedTemplate={setSelectedTemplate}
        templateName={templateName}
        setTemplateName={setTemplateName}
        setSavedData={setSavedData}
        setEditTemplate={setEditTemplate}
        loadTemplate={loadTemplate}
        createNewTemplate={createNewTemplate}
      />
      <main className="main-container row mx-0"> 
        <section className="col-2 px-0">
          <Sidebar 
          imageMedia={imageMedia}
          setImageMedia={setImageMedia}
          createTextBox={() => createTextBox("TextBox")}
          fontSize={fontSize}
          fontFamily={fontFamily}
          isBold={isBold}
          isItalic={isItalic}
          textDecoration={textDecoration}
          setFontSize={setFontSize}
          setFontFamily={setFontFamily}
          setTextBold={setTextBold}
          setTextItalic={setTextItalic}
          setTextDecoration={setTextDecoration}

          currentImage={currentImage}
          setCurrentImage={setCurrentImage}
          createImage={() => createImage("Image")}

          setBackgroundImage={setBackgroundImage} 

          fontList={fontList}

          orientation={orientation}
          setOrientation={setOrientation}
          shiftUp={shiftUp}
          shiftDown={shiftDown}
          createQrCode = {() => createImage("QrCode")}
          createCertNo = {() => createTextBox("CertNo")}
          certPrefix = {certPrefix}
          setCertPrefix = {setCertPrefix}
          />
        </section>
        <section className="col-10 px-0">
        <Topbar 
          fontList={fontList}
          createTextBox={() => createTextBox("TextBox")}
          createQrCode = {() => createImage("QrCode")}
          deleteItem={deleteItem}
          fontSize={fontSize}
          fontFamily={fontFamily}
          isBold={isBold}
          isItalic={isItalic}
          textColor={textColor}
          textDecoration={textDecoration}
          setFontSize={setFontSize}
          setFontFamily={setFontFamily}
          setTextBold={setTextBold}
          setTextItalic={setTextItalic}
          setTextDecoration={setTextDecoration}
          setTextColor={setTextColor}
          shiftDown={shiftDown}
          shiftUp={shiftUp}
          textAlignment={textAlignment}
          setTextAlignment={setTextAlignment}
        />
        <Canvas 
            stageRef={stageRef}
            onTextBoxSelect ={ onTextBoxSelect } 
            onTextBoxChange={onTextBoxChange}
            currentTextKey={currentTextKey} 
            selectedImageKey = {selectedImageKey}
            onImageSelect={onImageSelect} 
            imageObjects={ imageObjects } 
            onImageChange={ onImageChange } 
            background={ background } 
            bgImageObject = { bgImageObject }
            checkDeselect = {checkDeselect}
            addTextArea={addTextArea}
            textAreaVisibility={textAreaVisibility}
            setTextAreaVisibility={setTextAreaVisibility}
            textAreaStyle = {textAreaStyle}
            setTextAreaStyle={setTextAreaStyle}
            currentTextBoxText={currentTextBoxText}
            setCurrentTextBoxText = {setCurrentTextBoxText}
            orientation={orientation}
            certNoState={certNoState}
            objectState={objectState}
            fontFamily={fontFamily}
            fontSize={fontSize}
            textBoxRotation={textBoxRotation}
            textColor={textColor}
            />
        </section>
      </main>
    </div>
  );
}
 
export default TemplateEditor;